import React, { } from 'react';
import { animate, mix, motion, MotionValue, useMotionValue, useTime, useTransform } from 'motion/react';
import { useMediaQuery } from 'react-responsive';

const root = '/pips/';

const planetImages = [
    'd20.png',
    'd12.png',
    'd10.png',
    'd8.png',
    'd6.png',
]

interface PlanetProps {
    src: string,
    delay: number
}

const orbitDuration = 6500;
const yDistance = .2;
const xDistance = .6;
const zDistance = 1;
const circumference = 2 * Math.PI;
const zRadius = 1;
const scaleRange = mix(.95, 1.2) 

const Planet: React.FC<PlanetProps> = ({ src, delay }) => {
    const t = useTime();
    const theta = useTransform(() => ((t.get() + delay) / orbitDuration) * circumference);
    const isWide = useMediaQuery({ minWidth: 650 });
    const x = useTransform(() => Math.sin(theta.get()) * (isWide ? 500 : 300) * xDistance);
    const y = useTransform(() => Math.cos(theta.get()) * (isWide ? 500 : 300) * yDistance);
    const z = useTransform(() => Math.cos(theta.get()) * zRadius * zDistance);
    const scale = useTransform(() => scaleRange(Math.cos(theta.get())))

    const rotateZ = '-25deg';

    return (
        <motion.div className='absolute top-0 left-0 size-full flex justify-center items-center -rotate-12' style={{ zIndex: z }}>
            <motion.img
                layout
                src={src}
                className='absolute h-2/5'
                style={{
                    x, y,
                    scale,
                    zIndex: z,
                    translateX: '-50%',
                    translateY: '-50%',
                    rotateZ
                }}
            />
        </motion.div>
    )
}

interface SectionProps {
    hoverCB: Function,
    leaveCB: Function,
    height: MotionValue
}

const SectionPips: React.FC<SectionProps> = ({ height, hoverCB, leaveCB }) => {
    const nebulaX = useMotionValue('-50%');
    const nebulaY = useMotionValue('-50%');
    const nebulaZ = useMotionValue(0);

    const nebulaOpacity = useMotionValue(0);

    const handleOnHoverStart = () => {
        hoverCB();
        animate(nebulaOpacity, .98, { duration: 2, ease: 'easeInOut' })
    }

    const handleOnHoverEnd = () => {
        leaveCB();
        animate(nebulaOpacity, .05, { duration: 2, ease: 'easeInOut' })
    }


    return (
        <motion.div
            layout
            className='w-full flex justify-center items-center bg-slate-950 relative overflow-clip'
            style={{ height }}
            onHoverStart={handleOnHoverStart}
            onHoverEnd={handleOnHoverEnd}
        >


            <div className='size-full relative z-50'>
                <motion.img

                    src='/pips/xadart_galaxy.png'
                    className='absolute left-1/2 top-1/2 h-4/5 z-0'
                    style={{ x: nebulaX, y: nebulaY, z: nebulaZ, opacity: nebulaOpacity }}
                />
                {planetImages.map((v, i) => <Planet key={i} src={`${root}${v}`} delay={(orbitDuration * i / planetImages.length)} />)}
            </div>

            <div className='absolute top-0 left-0 size-full'>
                <motion.img className='size-full object-cover' src='/pips/pips_section_bg.jpg' />
            </div>

            <motion.div className='absolute bottom-0 right-0 pb-4 px-4 h-1/3 min-w-min'>
                <img className='h-full' src={'/pips/pips_logo.png'} />
            </motion.div>

            <div className='bottom-0 left-0 absolute pb-4 px-4'>
                <motion.h2 style={{}} className='min-w-max text-3xl lg:text-4xl text-gray-300 text-sun '>
                    PLANETARY PIPS
                </motion.h2>
            </div>
        </motion.div>
    )
}

export default SectionPips;